import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { applyCookieConsent } from "../lib/analytics";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (window.location.search.includes("embedded=1")) sessionStorage.setItem("eh_embedded", "1");
    if (sessionStorage.getItem("eh_embedded") === "1" || window.location.pathname.startsWith("/a/")) return;
    if (!localStorage.getItem("eh_cookie_consent")) setVisible(true);
  }, []);

  const choose = (choice) => {
    localStorage.setItem("eh_cookie_consent", choice);
    applyCookieConsent(choice);
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-[100] p-3 sm:p-4" data-testid="cookie-banner">
      <div className="max-w-3xl mx-auto bg-[#0F3D2E] text-white rounded-2xl shadow-2xl p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <Cookie className="w-5 h-5 text-emerald-300 shrink-0 hidden sm:block" />
        <p className="text-xs leading-relaxed text-white/80 flex-1">
          We use essential cookies to run the site, and — with your consent — Google Analytics and Google Ads
          cookies to measure and improve it. See our{" "}
          <a href="/privacy" className="underline text-emerald-300">Privacy Policy</a>.
        </p>
        <div className="flex gap-2 shrink-0">
          <button onClick={() => choose("essential")} data-testid="cookie-essential-btn"
            className="px-4 py-2 rounded-full text-xs font-semibold border border-white/25 text-white/80 hover:bg-white/10 transition-colors">
            Essential only
          </button>
          <button onClick={() => choose("all")} data-testid="cookie-accept-btn"
            className="px-4 py-2 rounded-full text-xs font-bold bg-emerald-500 hover:bg-emerald-400 text-white transition-colors">
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
};
